import React from 'react';
import { IAllocationProps } from 'src/components/enterprise/features/OrderHistory/OrderReceipt/OrderReceipt';
import { ReceiptLine } from 'src/components/enterprise/features/OrderHistory/OrderReceipt/ReceiptLine';

export function AllocationDetails({
  value,
}: {
  value: IAllocationProps[];
}): JSX.Element {
  if (value.length === 1) {
    const [allocation] = value;
    return <ReceiptLine name="Line of credit" value={allocation.amount} />;
  }

  return (
    <>
      {value.map(({ name, amount }) => (
        <ReceiptLine
          key={name}
          name={`Credit allocated from ${name}`}
          value={amount}
        />
      ))}
    </>
  );
}
